<template>
  <div id="login">
    <a-row :gutter="[0, 64]" class="container-logo">
      <a-col
        :md="{ span: 10, offset: 7 }"
        :xs="{ span: 22, offset: 1 }"
        :style="{ textAlign: 'center' }"
      >
        <a-icon
          v-if="!$store.state.headerLogo"
          class="logo-loading"
          type="loading"
        />
        <img
          v-else
          id="logo"
          :src="$store.state.headerLogo || livetubeLogoGrey"
        />
      </a-col>
    </a-row>
    <a-row class="container-login" justify="center" :gutter="[0, 64]">
      <a-form :form="form" :colon="false" @submit.prevent="handleRegister">
        <a-col
          class="section-register"
          :md="{ span: 10, offset: 7 }"
          :xs="{ span: 22, offset: 1 }"
        >
          <a-form-item label="First Name" class="eucerin-label" has-feedback>
            <a-input v-model="firstname" placeholder="First Name" />
          </a-form-item>
          <a-form-item label="Last Name" class="eucerin-label" has-feedback>
            <a-input v-model="lastname" placeholder="Last Name" />
          </a-form-item>
          <a-form-item label="Phone" class="eucerin-label" has-feedback>
            <a-input v-model="passcode" placeholder="Phone" />
          </a-form-item>
          <div class="flex items-center justify-between">
            <div class="flex">
              <input
                id="consent"
                name="consent"
                type="checkbox"
                class="
                  h-4
                  w-4
                  text-red-600
                  focus:ring-red-500
                  border-gray-300
                  rounded
                "
                v-model="accepted"
              />
              <label for="consent" class="ml-2 mb-5 block text-xs consent">
                ยืนยันการเข้าฟังคำบรรยายในวันที่ 3 กรกฎาคม 2565 เท่านั้น
              </label>
            </div>
          </div>

          <div class="group-button">
            <a-button
              v-if="!loading"
              type="primary"
              block
              html-type="submit"
              :disabled="accepted === false"
            >
              Register
            </a-button>
            <a-button v-if="loading" type="primary" block loading>
              Loading
            </a-button>
            <p class="section-already">
              Already registered?
              <router-link slot="title" :to="{ name: 'Login' }">
                Sign in
              </router-link>
            </p>
          </div>
        </a-col>
      </a-form>
    </a-row>
    <a-row :gutter="[0, 64]">
      <a-col
        :md="{ span: 10, offset: 7 }"
        :xs="{ span: 22, offset: 1 }"
        :style="{ textAlign: 'center' }"
        class="powered-by"
      >
        <a href="https://www.livetubex.com" class="link">
          Powered by <img id="small-logo" :src="livetubeLogoGrey" />
        </a>
      </a-col>
    </a-row>
    <div v-if="projectSlug == 'tma-tcc-2020'" class="sponsors">
      <picture>
        <source
          :srcset="require('@/assets/img/sponsors-mobile.png')"
          media="(max-width: 639px)"
          type="image/jpeg"
        />
        <source
          :srcset="require('@/assets/img/sponsors.png')"
          media="(min-width: 1024px)"
          type="image/jpeg"
        />
        <img :src="require('@/assets/img/sponsors.png')" alt="" />
      </picture>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import customCssMixins from '@/mixins/customCss.js'
export default {
  name: 'Login',
  components: {},
  mixins: [customCssMixins],
  metaInfo() {
    return {
      title: this.projectName,
      titleTemplate: '%s - LiveTube Portal',
    }
  },
  data() {
    return {
      accepted: false,
      loginBtn: false,
      isError: false,
      livetubeLogo: require('@/assets/logo.svg'),
      livetubeLogoGrey: require('@/assets/logo-grey.svg'),
      form: this.$form.createForm(this, { name: 'register' }),
      email: null,
      firstname: '',
      lastname: '',
      passcode: null,
      project: [],
      projectName: '',
      projectSlug: '',
      loading: false,
      modalImage: require('@/assets/img/how-to-watch.jpg?ver=1.2'),
      visible: false,
      confirmLoading: false,
    }
  },
  async mounted() {
    // if (this.$store.state.newDeviceLogin) {
    //   const key = `noti_${Date.now()}`
    //   this.$notification.error({
    //     message: this.$t('DUPLICATED_ALERT_TITLE'),
    //     description: `${this.$t('DUPLICATED_ALERT_DESC')}`,
    //     duration: 0,
    //     btn: (h) => {
    //       return h(
    //         'a-button',
    //         {
    //           props: {
    //             type: 'primary',
    //           },
    //           on: {
    //             click: () => this.$notification.close(key),
    //           },
    //         },
    //         'ปิด'
    //       )
    //     },
    //     key,
    //     onClose: close,
    //   })
    // }

    if (this.$route.query.email) {
      this.email = this.$route.query.email
    }

    if (this.$route.query.invite_code) {
      this.passcode = this.$route.query.invite_code
    }

    await this.$binding(
      'project',
      this.$db
        .collection('project')
        .where('project_slug', '==', this.$route.params.projectSlug)
    )

    if (!this.project[0]) {
      this.$router.push({ name: 'Home' })
    } else {
      this.projectName = this.project[0].name
      this.$store.commit('changeMutation', this.project[0].logo)
      if (this.project[0].project_slug) {
        this.projectSlug = this.project[0].project_slug
      }
    }
  },
  methods: {
    async registerSuccess() {
      await this.handleLogin()
    },
    handleChange() {
      this.loginBtn = true
    },
    async handleRegister() {
      this.loading = true
      try {
        const role = 'user'
        const name = `${this.firstname} ${this.lastname}`
        // const email = this.email
        const passCode = this.passcode
        const username =
          this.passcode + '_' + Math.random().toString(36).substr(2, 9)
        const email = username + '@eucerinlive.com'
        // this.email = email
        // const username =
        //   email.substring(0, email.lastIndexOf('@')) +
        //   '_' +
        //   Math.random().toString(36).substr(2, 9)

        // if (this.allowDuplicated !== true) {
        await this.$binding(
          'user',
          this.$db
            .collection('users')
            .where('project_slug', '==', this.$route.params.projectSlug)
            .where('invite_code', '==', this.passcode)
        )
        // .where('email', '==', email)

        if (this.user.length > 0) {
          this.loading = true
          // this.$error({
          //   title:
          //     'เบอร์ของคุณได้ถูกลงทะเบียนไว้เรียบร้อยแล้ว กรุณารอสักครู่...',
          // })
          // this.$success({
          //   title:
          //     'เบอร์ของคุณได้ถูกลงทะเบียนไว้เรียบร้อยแล้ว กำลังเข้าสู่ระบบอัตโนมัติ กรุณารอสักครู่...',
          // })
          await this.registerSuccess()
        } else {
          let alternativeEmail = null
          let uid = `${this.$route.params.projectSlug}-${email}`
          await this.$db.collection('users').doc(uid).set({
            uid: uid,
            role: role,
            registration_method: 'web',
            email: email,
            invite_code: passCode,
            username: username,
            name: name,
            alternative_email: alternativeEmail,
            session_key: [],
            project_slug: this.$route.params.projectSlug,
            rocket_chat_registered: false,
            created_at: this.$firebase.firestore.FieldValue.serverTimestamp(),
          })
          await this.registerSuccess()
        }
        // }
        this.loading = false
      } catch (error) {
        console.log(error)
        this.isError = true
        this.loading = false
      }
    },
    async handleLogin() {
      this.loading = true
      try {
        const authInfo = await axios.post(`${this.$apiUrl}/auth`, {
          project: this.$route.params.projectSlug,
          email: this.email,
          passcode: this.passcode,
        })
        await this.$auth.setPersistence(
          this.$firebase.auth.Auth.Persistence.LOCAL
        )
        this.$ga.set({ userId: this.email })
        this.$firebase.auth().signInWithCustomToken(authInfo.data.firebaseToken)
        localStorage[
          `auth:live-tube-portal:${this.$route.params.projectSlug}`
        ] = JSON.stringify(authInfo.data)
        await this.updateLoginStatus(authInfo.data)
        // await this.setLoginStatus(authInfo.data)
        // this.$store.commit('notiNewDeviceLogin', false)
        const currentUser = this.$auth.currentUser
        if (currentUser) {
          await this.setLoginStatus(authInfo.data)
        }
        const sessionSelected =
          this.$route.params.projectSlug === 'eucerin'
            ? 'eucerin-livestream'
            : 'eucerin-test-eucerin-test'
        this.$router.push({
          name: 'LiveSessions',
          params: {
            projectSlug: this.$route.params.projectSlug,
            sessionId: sessionSelected,
          },
        })
      } catch (error) {
        console.log(error)
        this.isError = true
        this.loading = false
      }
    },
    showModal() {
      this.visible = true
    },
    async updateLoginStatus(userData) {
      const userAgent = navigator.userAgent
      const docRef = this.$db.collection('login-status').doc(userData.uid)
      await docRef.set({
        user_id: userData.uid,
        uuid: localStorage.uuid,
        user_agent: userAgent,
        time: Date.now(),
      })
    },
    async setLoginStatus(userData) {
      const docRef = this.$rdb.ref(
        `user-login-status/${this.$route.params.projectSlug}/${userData.username}`
      )
      await docRef.set({
        uuid: localStorage.uuid,
        time: Date.now(),
      })
    },
  },
}
</script>

<style lang="scss">
// #logo {
//   width: 100%;
// }
.group-button {
  margin-bottom: 15px;

  &.-col-2 {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 15px;
  }
}

.section-already {
  margin-top: 15px;
}

.ant-modal-body {
  padding: 0;

  img {
    width: 100%;
  }
}

.ant-modal-close {
  color: #fff;
  z-index: 1000;
}

.ant-btn-primary {
  font-family: 'anuphan';
}

.powered-by {
  color: #d9d9d9;
  opacity: 0.5;
}

.powered-by .link {
  color: #d9d9d9;
}

#small-logo {
  width: 70px;
  vertical-align: baseline;
}

.intro {
  padding: 15px 0;
  text-align: center;

  &.-tcc {
    font-family: 'gotham';
    font-weight: 700;
  }
}

.alert {
  margin-bottom: 30px;
}

#login {
  padding-top: 30vh;
}
</style>
